var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFormSaved(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 107,
    viewBox: "0 0 73 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_163_27009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 52.725C0 52.725 45.0166 19.7684 43.2696 0C42.3961 1.75578 71.2412 39.9283 72.9921 49.8342C73.4289 49.6365 60.3185 97.6003 23.6041 107C23.6002 105.861 13.1103 71.1844 0 52.725Z",
    fill: "#E4E9F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4141 50.6883L24.9971 48.984C25.0915 48.9603 34.6527 46.2989 47.7788 25.447L49.2583 26.3881C35.6718 47.9637 25.8273 50.5895 25.4141 50.6883Z",
    fill: "#9EB1CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7574 66.5499L37.2813 64.8613L37.5213 65.7075L37.2773 64.8613C37.3718 64.8336 46.8307 61.8282 59.1974 40.5176L60.7083 41.4034C47.9088 63.4574 38.1627 66.4352 37.7574 66.5499Z",
    fill: "#9EB1CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7458 60.6141C18.5125 60.6141 19.9447 59.1746 19.9447 57.399C19.9447 55.6234 18.5125 54.1841 16.7458 54.1841C14.9791 54.1841 13.5469 55.6234 13.5469 57.399C13.5469 59.1746 14.9791 60.6141 16.7458 60.6141Z",
    fill: "#9EB1CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2059 77.0211C27.0573 77.0211 28.5582 75.5127 28.5582 73.6519C28.5582 71.7912 27.0573 70.2827 25.2059 70.2827C23.3544 70.2827 21.8535 71.7912 21.8535 73.6519C21.8535 75.5127 23.3544 77.0211 25.2059 77.0211Z",
    fill: "#9EB1CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_163_27009"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 107,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormSaved);
export default __webpack_public_path__ + "static/media/form-saved.e8837068a89c7eebb9e512cdea097d21.svg";
export { ForwardRef as ReactComponent };